import React from 'react';
import { useTranslation } from 'react-i18next';

import { getThemeLogoById } from '../../theme/theme.utils';
import {
  CoveragePolicyStatus,
} from '../insurance/coverageOverview/CoveragePolicyStatus';

import { MARKETING_CHANNEL_ID } from '../../theme/theme.constants';
import { formatShortDateByLanguage } from '../../services/language.utils';

import './PolicyListItem.css';

const PolicyListItem = ({
  disabled = false,
  endsOn,
  marketingChannel,
  onClick = () => { },
  policyNumber,
  selected = false,
  startsOn,
  status,
  statusId,
}) => {
  const { t } = useTranslation('fileClaimbot');
  const { dark } = getThemeLogoById(marketingChannel);
  const formattedStartDate = startsOn
    ? formatShortDateByLanguage(startsOn) : '-';
  const formattedEndDate = endsOn
    ? formatShortDateByLanguage(endsOn) : '-';

  return (
    <li className="Policy-list-item-container">
      <button
        data-selected={selected}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        <div className="Policy-list-item-data">
          <div className="Policy-list-item-logo-container">
            <img
              alt=""
              className="Policy-list-item-logo"
              data-marketingchannel={marketingChannel}
              src={dark}
            />
          </div>

          <div className="Policy-list-item-content">
            <div>
              <h3>{t('policySelector.policyNumber')}</h3>

              <p>{policyNumber}</p>
            </div>

            <div>
              <h3>
                {marketingChannel !== MARKETING_CHANNEL_ID.figo
                  ? t('policySelector.coveragePeriod')
                  : t('policySelector.policyTerm')}
              </h3>

              <p>{`${formattedStartDate} - ${formattedEndDate}`}</p>
            </div>
          </div>
        </div>

        <CoveragePolicyStatus
          label={status}
          status={statusId}
        />
      </button>
    </li>
  );
};

export { PolicyListItem };
